__turbopack_context__.v({
  "alwaysShrink": "bMiiYq_alwaysShrink",
  "container": "bMiiYq_container",
  "hasGeneralBanner": "bMiiYq_hasGeneralBanner",
  "headerHidden": "bMiiYq_headerHidden",
  "headerStack": "bMiiYq_headerStack",
  "navbarShrinked": "bMiiYq_navbarShrinked",
  "navbarWrapper": "bMiiYq_navbarWrapper",
  "spacer": "bMiiYq_spacer",
  "wrapper": "bMiiYq_wrapper",
});
